import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import Slider from "react-slick";
// import images
import {
  pointerImg,
  btnAndriodImg,
  btnIosImg,
  whereImg,
  timeImg,
  deviceImg,
  about1Img,
  service1Img,
  service2Img,
  service3Img,
  service4Img,
  service5Img,
  service6Img,
  service7Img,
  videoImg,
} from "../assets/images";

const Home = ({ videoData, videoBaseUrl, bannerData, frontServices, frontServiceImageUrl }) => {
  const [showMore, setShowMore] = useState(false);
  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    dots: false,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          dots: true,
          arrows: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          dots: true,
          arrows: false,
        },
      },
    ],
  };
  return (
    <>
      <section className="home_banner_block">
        <Container className="h-100">
          <div className="banner_content ">
            <div className="banner_text">
              <h1 className="banner_title pb-1">
                <span className="color-red">
                  {bannerData?.banner_title_red || "Save"}
                </span>{" "}
                {bannerData?.banner_title_text || "Time & Money"}
              </h1>
              <p className="banner-text m-0 text-center px-2 px-md-0">
                {bannerData?.banner_description_one || "Help around the home is just a few"}{" "}
                <img src={pointerImg} className="px-1" />{" "}
                {bannerData?.banner_description_two || "clicks away"}{" "}
              </p>
            </div>
            <div className="banner_btn pt-3 pt-md-0">
              <p className="m-0 pb-2 lead_text">
                What are waiting for! <strong>Download App</strong>
              </p>
              <div className="d-flex mx-n1">
                <a
                  href="https://apps.apple.com/us/developer/help-lah-pte-ltd/id1633038172"
                  target="_blank"
                  className="px-1"
                >
                  <img src={btnAndriodImg} alt="" />
                </a>
                <a
                  href="https://play.google.com/store/apps/developer?id=Help+Lah+Pte+Ltd"
                  target="_blank"
                  className="px-1"
                >
                  <img src={btnIosImg} alt="" />
                </a>
              </div>
            </div>
          </div>
        </Container>
      </section>

      {/* about_sec */}

      <section className="about_sec">
        <Container>
          <Row>
            <Col xs={12} md={8}>
              <div className="heading_sec">
                <h2 className="text-white">
                  The easiest way to engage a{" "}
                  <span className="text-dark">
                    reliable service professional
                  </span>{" "}
                  at
                </h2>
              </div>
              <div className="about_content">
                <ul>
                  <li>
                    <img src={timeImg} />
                    <h4>
                      Any <span className="text-dark">Time</span>
                    </h4>
                  </li>
                  <li>
                    <img src={whereImg} alt="" />
                    <h4>
                      Any <span className="text-dark">Where</span>
                    </h4>
                  </li>
                  <li>
                    <img src={deviceImg} alt="" />
                    <h4>
                      Any <span className="text-dark">Device</span>
                    </h4>
                  </li>
                </ul>
                <h3 className="text-center text-white">
                  We can <span className="text-dark">FIX IT!!</span>
                </h3>
              </div>
            </Col>

            <Col xs={12} md={4} className="about_right">
              <div className="about_img">
                <img src={about1Img} />
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* about_sec */}

      {/* service_sec */}

      <section className="service_sec">
        <Container>
          <div className="heading_sec text-center pb-3 pb-md-4">
            <h2 className="title text-black">Our Services</h2>
          </div>
          <Row className="no-gutters service_list">
            <Col xs={6} sm={4} lg={3}>
              <Link to="/inquiry?service=Handyman" className="box d-block">
                <img src={service1Img} alt="service" />
                <h3 className="title">Handyman</h3>
              </Link>
            </Col>
            <Col xs={6} sm={4} lg={3}>
              <Link to="/inquiry?service=Electrical Repair" className="box d-block">
                <img src={service2Img} alt="service" />
                <h3 className="title">Electrical Repair</h3>
              </Link>
            </Col>
            <Col xs={6} sm={4} lg={3}>
              <Link to="/inquiry?service=Carpentry Repair" className="box d-block">
                <img src={service3Img} alt="service" />
                <h3 className="title">Carpentry Repair</h3>
              </Link>
            </Col>
            <Col xs={6} sm={4} lg={3}>
              <Link to="/inquiry?service=Aircon Servicing" className="box d-block">
                <img src={service4Img} alt="service" />
                <h3 className="title">Aircon Servicing</h3>
              </Link>
            </Col>

            <Col xs={6} sm={4} lg={3}>
              <Link to="/inquiry?service=Plumbing" className="box d-block">
                <img src={service5Img} alt="service" />
                <h3 className="title">Plumbing</h3>
              </Link>
            </Col>

            <Col xs={6} sm={4} lg={3}>
              <Link to="/inquiry?service=Painting" className="box d-block">
                <img src={service6Img} alt="service" />
                <h3 className="title">Painting</h3>
              </Link>
            </Col>

            <Col xs={6} sm={4} lg={3}>
              <Link to="/inquiry?service=Home Cleaning" className="box d-block">
                <img src={service7Img} alt="service" />
                <h3 className="title">Home Cleaning </h3>
              </Link>
            </Col>

            {showMore &&
              frontServices &&
              frontServices.length > 0 &&
              frontServices.map((service, index) => (
                <Col xs={6} sm={4} lg={3} key={index}>
                  <Link
                    to={`/inquiry?service=${service.name}`}
                    className="box d-block"
                  >
                    <img
                      src={frontServiceImageUrl + "/" + service.image}
                      alt={service.name}
                    />
                    <h3 className="title">{service.name}</h3>
                  </Link>
                </Col>
              ))}

            <Col xs={6} sm={4} lg={3}>
              <Link
                to={
                  showMore || !frontServices || frontServices.length === 0
                    ? "/inquiry"
                    : "#"
                }
                onClick={(e) => {
                  if (
                    !showMore &&
                    frontServices &&
                    frontServices.length > 0
                  ) {
                    e.preventDefault();
                    setShowMore(true);
                  }
                }}
                className="box much_more_box d-flex align-items-center justify-content-center"
              >
                <div className="much_more_content text-center">
                  <h4> & Much More </h4>
                  <span className="arrow">
                    {" "}
                    <i className="fas fa-arrow-right"></i>{" "}
                  </span>
                </div>
              </Link>
            </Col>
          </Row>
        </Container>
      </section>

      {/* service_sec */}

      {/* work_sec */}

      <section className="work_sec">
        <Container>
          <div className="heading_sec text-center pb-3 pb-md-4">
            <h2 className="title text-black">How it Works</h2>
          </div>

          <div className="text-center video_box">
            {videoData ? (
              videoData.video_type === 1 ? (
                <video
                  width="750"
                  height="500"
                  controls
                  controlsList="nodownload"
                  key={videoData.video}
                >
                  <source
                    src={videoBaseUrl + videoData.video}
                    type="video/mp4"
                  />
                </video>
              ) : (
                <iframe
                  width="750"
                  height="500"
                  src={
                    videoData.video.includes("watch?v=")
                      ? videoData.video.replace("watch?v=", "embed/")
                      : videoData.video.includes("youtu.be/")
                      ? videoData.video.replace(
                          "youtu.be/",
                          "youtube.com/embed/"
                        )
                      : videoData.video
                  }
                  title="YouTube video player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              )
            ) : (
              <video
                width="750"
                height="500"
                controls
                controlsList="nodownload"
              >
                <source src="Helplah.mp4" type="video/mp4" alt="vvvv" />
              </video>
            )}
          </div>
        </Container>
      </section>

      {/* work_sec */}

      {/* testmonial_sec */}

      <section className="testimonial_sec">
        <Container>
          <div className="heading_sec text-center  pb-3 pb-md-4">
            <h2 className="title text-black">Testimonial</h2>
          </div>
          <Row>
            <Col lg="10" className="m-auto">
              <Slider {...settings}>
                <div className="test_slider">
                  <h4>PARQUET FLOOR RE-VARNISH</h4>
                  <p>
                    <span>“Fast respond and Excellent Service.</span> Appreciate
                    the works done. Look as good as new flooring!”
                  </p>
                  <div className="star">
                    <i class="fas fa-star"></i>
                    <i class="fas fa-star"></i>
                    <i class="fas fa-star"></i>
                    <i class="fas fa-star"></i>
                    <i class="fas fa-star"></i>
                  </div>
                  <h6>Ms Lin, St. Michael’s Road</h6>
                </div>

                <div className="test_slider">
                  <h4>ELECTRICAL POWER FAILURE</h4>
                  <p>
                    <span>“Fast respond and reasonable price.</span> Appreciate
                    the works done. I will use his service in the next future!”
                  </p>
                  <div className="star">
                    <i class="fas fa-star"></i>
                    <i class="fas fa-star"></i>
                    <i class="fas fa-star"></i>
                    <i class="fas fa-star"></i>
                    <i class="fas fa-star"></i>
                  </div>
                  <h6>Ms Ivy Hew, Teban Gardens</h6>
                </div>

                <div className="test_slider">
                  <h4>ELECTRICAL POWER FAILURE</h4>
                  <p>
                    <span>“A BIG THANK TO HELP LAH!</span> Really appreciate the
                    painting job done and your personal attendance too. Will
                    Spread the word around for Help Lah!!”
                  </p>
                  <div className="star">
                    <i class="fas fa-star"></i>
                    <i class="fas fa-star"></i>
                    <i class="fas fa-star"></i>
                    <i class="fas fa-star"></i>
                    <i class="fas fa-star"></i>
                  </div>
                  <h6>Mr Tan, Toa Payoh</h6>
                </div>
              </Slider>
            </Col>
          </Row>
        </Container>
      </section>

      {/* testmonial_sec */}
    </>
  );
};

export default Home;
